import { useTranslations } from "next-intl";
import { Navigate } from "react-router-dom";
import { SCard } from "@/components/Card/SCard";
import { AuthLayout } from "./AuthLayout";
import { CheckEmailContent } from "./check-email/CheckEmailContent";

function readLs(name: string): string | null {
  try { return localStorage.getItem(name); } catch { return null; }
}

export function CheckEmailPage() {
  const t = useTranslations("checkEmail");
  const email = readLs("email");
  const origin = readLs("origin");

  if (
    !email ||
    !origin ||
    (origin !== "register" &&
      origin !== "register-invite" &&
      origin !== "reset-password")
  ) {
    return <Navigate to="/login" replace />;
  }

  const emailResend = Number(readLs("emailResend") || 0);
  const cooldownRemaining = Math.max(0, Math.floor((emailResend - Date.now()) / 1000));

  return (
    <AuthLayout>
      <SCard header={t("title")} outline="outline-quaternary" shadow="shadow-xl">
        <CheckEmailContent
          email={email}
          origin={origin as "register" | "register-invite" | "reset-password"}
          cooldownRemaining={cooldownRemaining}
        />
      </SCard>
    </AuthLayout>
  );
}
